module.exports = __webpack_public_path__ + "img/american-express.14c1c2e0.png";